<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="82px">
        <el-form-item label="老板评价">
          <el-select v-model="editData.workevaluation" placeholder="请选择评价" class="select"  style="width: 180px;">
            <el-option label="待评价" value="0"></el-option>
            <el-option label="达标" value="1"></el-option>
            <el-option label="待达标" value="2"></el-option>
            <el-option label="良" value="3"></el-option>
            <el-option label="优" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editData: {
        workevaluation: '0',
      },
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetDevicepause()
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiPostWorkbenchStatisticalValuation()
    },
    apiPostWorkbenchStatisticalValuation: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workbenchid: that.parentdata.workbenchid,
        workevaluation: that.editData.workevaluation
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_PostWorkbenchStatisticalValuation, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
